import React, { useState } from "react";
import Sidebar from "../../Sidebar/Sidebar";
import "./UserDetails.css";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import leftArrow from "../../../../assests/leftArrow.svg";
import profile from "../../../../assests/gprofile.svg";
import Avatar from "../../../../assests/Avatar.png";
import uid from "../../../../assests/uid.svg";
import phone1 from "../../../../assests/phone11.svg";
import warehouse from "../../../../assests/warehouse.svg";
import mail from "../../../../assests/mail.svg";
import cohorts from "../../../../assests/cohorts.svg";
import watch from "../../../../assests/watch.svg";
import calander from "../../../../assests/calander.svg";
import editIcon from "../../../../assests/bosEdit.svg";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";
import verifiedIcon from "../../../../assests/verifiedIcon.svg";
import notverifiedIcon from "../../../../assests/notverifiedIcon.svg";
import employeeCode from "../../../../assests/employeeCode.svg";
import moment from "moment";
import { useParams } from "react-router-dom";

// Individual Field Component with Radio List
const EditableField = ({
  label,
  value,
  displayValue,
  options = [],
  onSave,
  currencySymbol = false,
  loading = false,
  isOpen = false,
  onOpenChange
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const [tempSelectedValue, setTempSelectedValue] = useState(value);

  React.useEffect(() => {
    if (isOpen !== undefined) {
      setIsEditing(isOpen);
    }
  }, [isOpen]);

  const handleEditClick = () => {
    setIsEditing(true);
    setTempSelectedValue(selectedValue);
    if (onOpenChange) onOpenChange(label);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setTempSelectedValue(selectedValue);
    if (onOpenChange) onOpenChange(null);
  };

  const handleSave = () => {
    setIsEditing(false);
    setSelectedValue(tempSelectedValue);
    if (onSave) onSave(tempSelectedValue);
    if (onOpenChange) onOpenChange(null);
  };

  const handleRadioChange = (optionId) => {
    setTempSelectedValue(optionId);
  };

  const optionsArray = Array.isArray(options) ? options : [];

  const getSelectedOptionName = () => {
    if (!selectedValue || selectedValue === "") return "Not Set";
    
    const selectedOption = optionsArray.find(opt => {
      const optId = opt.id || opt.salaryTypeId || opt.vehicleTypeId;
      return optId == selectedValue;
    });
    
    if (selectedOption) {
      return selectedOption.salaryTypeName || 
             selectedOption.name || 
             selectedOption.salaryType || 
             selectedOption.vehicleType || 
             selectedOption.vehicleTypeName || 
             selectedOption;
    }
    
    return displayValue || selectedValue;
  };

  const displayText = getSelectedOptionName();

  return (
    <div className="emp-config-field-group">
      <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
        <label className="emp-config-label">{label}</label>
        {!isEditing && (
          <button 
            className="emp-config-field-edit" 
            onClick={handleEditClick}
            disabled={loading}
          >
            <img src={editIcon} alt="Edit" className="emp-config-edit-icon" />
          </button>
        )}
      </div>
     
      <div className="emp-config-value-wrapper">
        {isEditing ? (
          <>
            <div className="emp-config-radio-list">
              {optionsArray.map((option) => {
                const optionId = option.id || option.salaryTypeId || option.vehicleTypeId;
                const optionName = option.salaryTypeName || 
                                  option.name || 
                                  option.salaryType || 
                                  option.vehicleType || 
                                  option.vehicleTypeName || 
                                  "Unknown";
                const isChecked = tempSelectedValue == optionId;
                
                return (
                  <label key={optionId} className="emp-config-radio-item">
                    <input
                      type="radio"
                      name={label}
                      value={optionId}
                      checked={isChecked}
                      onChange={() => handleRadioChange(optionId)}
                      className="emp-config-radio-input"
                      disabled={loading}
                    />
                    <span className="emp-config-radio-label-text">{optionName}</span>
                  </label>
                );
              })}
            </div>
            
            <div className="emp-config-field-footer">
              <button 
                className="emp-config-field-cancel" 
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                className="emp-config-field-save" 
                onClick={handleSave}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="emp-config-value">
              {currencySymbol && "₹ "}
              {displayText && displayText !== "null" && displayText !== "undefined" && displayText !== "" ? displayText : "Not Set"}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// Basic Config Field Component (Number Input) - With Max 6 Digits
const BasicConfigField = ({
  label,
  value,
  onSave,
  currencySymbol = false,
  loading = false,
  isOpen = false,
  onOpenChange
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState(value);

  React.useEffect(() => {
    if (isOpen !== undefined) {
      setIsEditing(isOpen);
    }
  }, [isOpen]);

  const handleEditClick = () => {
    setIsEditing(true);
    setEditedValue(value);
    if (onOpenChange) onOpenChange(label);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedValue(value);
    if (onOpenChange) onOpenChange(null);
  };

  const handleSave = () => {
    setIsEditing(false);
    // Ensure value is a number with 2 decimal places
    let finalValue = editedValue;
    if (finalValue && !isNaN(parseFloat(finalValue))) {
      finalValue = parseFloat(finalValue).toFixed(2);
    }
    if (onSave) onSave(finalValue);
    if (onOpenChange) onOpenChange(null);
  };

  // Handle input change with max 6 digits validation
  const handleInputChange = (e) => {
    let inputValue = e.target.value;
    
    // Remove any non-digit characters except decimal point
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    
    // Ensure only one decimal point
    const decimalCount = (inputValue.match(/\./g) || []).length;
    if (decimalCount > 1) return;
    
    // Split into integer and decimal parts
    const parts = inputValue.split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];
    
    // Limit integer part to 6 digits
    if (integerPart && integerPart.length > 6) {
      integerPart = integerPart.slice(0, 6);
    }
    
    // Limit decimal part to 2 digits
    let newValue = integerPart;
    if (decimalPart !== undefined) {
      newValue += '.' + decimalPart.slice(0, 2);
    }
    
    setEditedValue(newValue);
  };

  // Format display value
  const formatDisplayValue = (val) => {
    if (!val || val === "null" || val === "undefined" || val === "") return "Not Set";
    
    // If it's a number, format with 2 decimal places
    const num = parseFloat(val);
    if (!isNaN(num)) {
      return num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return val;
  };

  return (
    <div className="emp-config-field-group">
      <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
        <label className="emp-config-label">{label}</label>
        {!isEditing && (
          <button 
            className="emp-config-field-edit" 
            onClick={handleEditClick}
            disabled={loading}
          >
            <img src={editIcon} alt="Edit" className="emp-config-edit-icon" />
          </button>
        )}
      </div>
     
      <div className="emp-config-value-wrapper">
        {isEditing ? (
          <>
            <div className="emp-config-input-wrapper">
              {currencySymbol && (
                <span className="emp-config-currency">₹</span>
              )}
              <input
                type="text"
                className="emp-config-input"
                value={editedValue}
                onChange={handleInputChange}
                placeholder="Enter amount (Max 6 digits)"
                disabled={loading}
                maxLength={9}
              />
            </div>
           
            <div className="emp-config-field-footer">
              <button 
                className="emp-config-field-cancel" 
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                className="emp-config-field-save" 
                onClick={handleSave}
                disabled={loading}
              >
                Save
              </button>
            </div>
          </>
        ) : (
          <div className="emp-config-value">
            {currencySymbol && "₹ "}
            {formatDisplayValue(value)}
          </div>
        )}
      </div>
    </div>
  );
};

// Employee Configuration Component
const EmployeeConfiguration = ({ 
  employeeConfig, 
  salaryTypes, 
  vehicleTypes, 
  configLoading, 
  onFieldUpdate 
}) => {
  const [openSection, setOpenSection] = useState(null);

  // Format basic config value - handle nested object structure
  const getBasicConfigValue = () => {
    if (!employeeConfig) return "";
    
    // Handle nested basic object structure
    if (employeeConfig.basic) {
      if (employeeConfig.basic.activeBasic) {
        return employeeConfig.basic.activeBasic.toFixed(2);
      }
      if (employeeConfig.basic.warehouseDefault?.monthlyBasic) {
        return employeeConfig.basic.warehouseDefault.monthlyBasic.toFixed(2);
      }
    }
    
    // Handle flat structure
    if (employeeConfig.basicConfig) {
      return typeof employeeConfig.basicConfig === 'number' 
        ? employeeConfig.basicConfig.toFixed(2) 
        : employeeConfig.basicConfig;
    }
    
    return "";
  };

  // Get salary type ID for editing
  const getSalaryTypeId = () => {
    if (employeeConfig?.salaryType?.salaryTypeId) {
      return employeeConfig.salaryType.salaryTypeId;
    }
    if (employeeConfig?.salaryTypeId) {
      return employeeConfig.salaryTypeId;
    }
    return "";
  };

  // Get salary type display name
  const getSalaryTypeDisplay = () => {
    if (!employeeConfig) return "Not Set";
    
    // Handle nested salaryType object
    if (employeeConfig.salaryType?.salaryTypeName) {
      return employeeConfig.salaryType.salaryTypeName;
    }
    
    // Handle flat structure
    if (employeeConfig.salaryTypeId && salaryTypes.length > 0) {
      const found = salaryTypes.find(st => (st.id == employeeConfig.salaryTypeId) || (st.salaryTypeId == employeeConfig.salaryTypeId));
      if (found) {
        return found.salaryTypeName || found.name || found.salaryType;
      }
    }
    
    if (employeeConfig.salaryType) {
      return employeeConfig.salaryType;
    }
    
    return "Not Set";
  };

  // Get vehicle type ID for editing
  const getVehicleTypeId = () => {
    if (employeeConfig?.vehicle?.vehicleTypeId) {
      return employeeConfig.vehicle.vehicleTypeId;
    }
    if (employeeConfig?.vehicleTypeId) {
      return employeeConfig.vehicleTypeId;
    }
    return "";
  };

  // Get vehicle type display name
  const getVehicleTypeDisplay = () => {
    if (!employeeConfig) return "Not Set";
    
    // Handle nested vehicle object
    if (employeeConfig.vehicle?.vehicleType) {
      return employeeConfig.vehicle.vehicleType;
    }
    
    // Handle flat structure
    if (employeeConfig.vehicleTypeId && vehicleTypes.length > 0) {
      const found = vehicleTypes.find(vt => (vt.id == employeeConfig.vehicleTypeId) || (vt.vehicleTypeId == employeeConfig.vehicleTypeId));
      if (found) {
        return found.vehicleType || found.name;
      }
    }
    
    if (employeeConfig.vehicleType) {
      return employeeConfig.vehicleType;
    }
    
    return "Not Set";
  };

  const handleOpenChange = (sectionName) => {
    setOpenSection(sectionName);
  };

  const basicConfigValue = getBasicConfigValue();
  const salaryTypeId = getSalaryTypeId();
  const salaryTypeDisplay = getSalaryTypeDisplay();
  const vehicleTypeId = getVehicleTypeId();
  const vehicleTypeDisplay = getVehicleTypeDisplay();

  return (
    <div className="emp-config-section">
      <div className="emp-config-header">
        <h2 className="emp-config-title">
          <svg
            className="emp-config-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
              fill="currentColor"
            />
          </svg>
          Employee Configuration
        </h2>
      </div>

      <div className="emp-config-content">
        {configLoading && !employeeConfig?.salaryType ? (
          <div className="emp-config-loading">Loading configuration...</div>
        ) : (
          <div className="emp-config-fields">
            {/* Salary Type - Radio List */}
            <EditableField
              label="SALARY TYPE"
              value={salaryTypeId}
              displayValue={salaryTypeDisplay}
              options={salaryTypes}
              onSave={(value) => onFieldUpdate("salaryType", value)}
              loading={configLoading}
              isOpen={openSection === "SALARY TYPE"}
              onOpenChange={handleOpenChange}
            />

            {/* Vehicle Type - Radio List */}
            <EditableField
              label="VEHICLE TYPE"
              value={vehicleTypeId}
              displayValue={vehicleTypeDisplay}
              options={vehicleTypes}
              onSave={(value) => onFieldUpdate("vehicleType", value)}
              loading={configLoading}
              isOpen={openSection === "VEHICLE TYPE"}
              onOpenChange={handleOpenChange}
            />

            {/* Basic Config - Input Field with Max 6 Digits */}
            <BasicConfigField
              label="BASIC CONFIG"
              value={basicConfigValue}
              currencySymbol={true}
              onSave={(value) => onFieldUpdate("basicConfig", value)}
              loading={configLoading}
              isOpen={openSection === "BASIC CONFIG"}
              onOpenChange={handleOpenChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const UserDetailsComp = ({ 
  data, 
  loading, 
  employeeConfig, 
  salaryTypes, 
  vehicleTypes, 
  configLoading, 
  onFieldUpdate 
}) => {
  const { userid } = useParams();
  const navigate = useNavigate();

  const handleBack = () => navigate("/home/users/list");

  // Check if user is Delivery Boy (role_id = 4)
  const isDeliveryBoy = data?.userRole?.role_id === 4;

  // Function to construct correct image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath || imagePath === "null" || imagePath === "undefined") {
      return null;
    }

    const cleanPath = imagePath.split("?")[0];

    if (cleanPath.startsWith("http")) {
      return cleanPath;
    }

    const pathWithoutProductPrefix = cleanPath.startsWith("product/")
      ? cleanPath.substring("product/".length)
      : cleanPath;

    return `https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/product/${pathWithoutProductPrefix}`;
  };

  const imageUrl = data?.userDetails?.imageUrl
    ? getImageUrl(data.userDetails.imageUrl)
    : null;

  return (
    <div className="user-details-container">
      <Sidebar />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="user-details-content">
          <div className="users-details-header">
            <div className="header-title-container">
              <button className="back-button" onClick={handleBack}>
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>User Details</h1>
            </div>
          </div>

          <div className="information-container">
            {data?.userDetails && (
              <div className="basic-info-section">
                <div className="section-header">
                  <h2>
                    <img src={profile} alt="Profile" /> Basic Information
                  </h2>
                  <Button className="edit-button">
                    <Link to={`/updateuserdetails/${userid}`}>Edit</Link>
                  </Button>
                </div>

                <div className="background-container">
                  <div className="user-info-container">
                    <div className="user-profile-card">
                      <div className="user-designation">
                        <div className="user-image-container">
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={data.userDetails.full_name || "User"}
                              className="user-main-image"
                              onError={(e) => {
                                console.error(
                                  "Image failed to load, showing fallback avatar"
                                );
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                              style={{
                                height: "100px",
                                width: "100px",
                                borderRadius: "10px"
                              }}
                              loading="lazy"
                            />
                          ) : null}
                          <div
                            className="user-image-placeholder"
                            style={{ display: imageUrl ? "none" : "flex" }}
                          >
                            <img
                              className="user-avatar"
                              src={Avatar}
                              alt="User Avatar"
                              loading="lazy"
                            />
                          </div>
                        </div>

                        <div className="user-info">
                          <h3>{data.userDetails.full_name}</h3>
                          <span>{data.userRole?.role_name}</span>
                          <div className="verification-status">
                            {data.userDetails.verificationStatus ===
                            "verified" ? (
                              <>
                                <img src={verifiedIcon} alt="Verified" />
                                <span className="verified-text">Verified</span>
                              </>
                            ) : (
                              <>
                                <img src={notverifiedIcon} alt="Not Verified" />
                                <span className="not-verified-text">
                                  Not Verified
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                        <div
                          className={`status-badge ${data.userDetails.status}`}
                        >
                          <p>{data.userDetails.status}</p>
                        </div>
                      </div>
                    </div>

                    <div className="user-details-card">
                      <ul className="details-list">
                        <li className="detail-item">
                          <img src={uid} alt="User ID" />
                          <p>User ID: {data.userDetails.id}</p>
                        </li>
                        <li className="detail-item">
                          <img src={employeeCode} alt="Employee Code" />
                          <p>
                            Employee Code: {data.userDetails.employeeCode || "N/A"}
                          </p>
                        </li>
                        <li className="detail-item">
                          <img src={phone1} alt="Phone" />
                          <p>{data.userDetails.mobile}</p>
                        </li>
                        <li className="detail-item">
                          <img src={mail} alt="Email" />
                          <p>{data.userDetails.email}</p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="login-info-container">
                    <ul className="login-details">
                      <li className="login-item">
                        <img src={watch} alt="Since" />
                        <p>
                          Member since: <br />
                          <strong>
                            {moment
                              .utc(data.userDetails.since)
                              .local()
                              .format("DD/MM/YYYY HH:mm A")}
                          </strong>
                        </p>
                      </li>
                      <li className="login-item">
                        <img src={calander} alt="Last Login" />
                        <p>
                          Last login: <br />
                          <strong>
                            {moment
                              .utc(data.userDetails.last_login)
                              .local()
                              .format("DD/MM/YYYY HH:mm A")}
                          </strong>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {data?.warehouse && (
              <div className="warehouse-section">
                <div className="section-header">
                  <h2>
                    <img src={warehouse} alt="Warehouse" /> Warehouse
                  </h2>
                  <Button className="edit-button">
                    <Link to={`/updatewarehouse/${userid}`}>Edit</Link>
                  </Button>
                </div>
                <div className="warehouse-content">
                  <p className="warehouse-description">
                    The user is added in the below warehouse
                  </p>
                  <div className="warehouse-details">
                    <h3>{data.warehouse.name}</h3>
                    <p>{data.warehouse.id}</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Employee Configuration Section - Only show for Delivery Boy (role_id = 4) */}
          {isDeliveryBoy && (
            <EmployeeConfiguration
              employeeConfig={employeeConfig}
              salaryTypes={salaryTypes}
              vehicleTypes={vehicleTypes}
              configLoading={configLoading}
              onFieldUpdate={onFieldUpdate}
            />
          )}

          <div className="cohorts-section">
            <div className="section-header">
              <h2>
                <img src={cohorts} alt="Cohorts" /> Cohorts
              </h2>
              <Button className="edit-button">
                <Link to={`/updatecohortdetails/${userid}`}>Edit</Link>
              </Button>
            </div>

            <div className="cohorts-content">
              <p className="cohorts-description">
                The user is added in the below cohorts
              </p>
              <div className="table-responsive">
                <Table hover responsive className="cohorts-table">
                  <thead>
                    <tr>
                      <th>Cohort ID</th>
                      <th>Cohort Name</th>
                      <th>Area Name</th>
                      <th>Cohort Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.cohorts?.length > 0 ? (
                      data.cohorts.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.name}</td>
                          <td>{item.area_name}</td>
                          <td>
                            <div className="cohort-type-badge">
                              <p>{item.cohort_type_name}</p>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="no-cohorts">
                          No cohorts assigned
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetailsComp;